import React, { useState } from 'react'
import {Row,Col,Form} from 'react-bootstrap'
import Header from '../Component/Header';
import PageHead from '../Component/pageHead';
import Footer from '../Component/footer';
import {useFormik} from 'formik';
import {PostAction} from '../Component/PostAction';
import { useHistory } from "react-router-dom";

const initialformData = {
    username:'',
    password:'',
  }

function storeVal(key, value) {
  sessionStorage.setItem(key, value == null ? '' : String(value))
}

function storeSession(item, meta = {}) {
  const permissions = item.permissions ?? meta.permissions ?? []
  const roleIds = item.role_ids ?? meta.role_ids ?? []
  const roleName = item.role_name ?? meta.role_name ?? ''
  const canAccessAdmin = item.can_access_admin ?? meta.can_access_admin ?? false
  const userRole = item.user_role ?? meta.role_id ?? ''
  const token = String(item.id)

  storeVal("id", item.id);
  storeVal("token", token);
  storeVal("name", item.name);
  storeVal("first_name", item.first_name);
  storeVal("last_name", item.last_name);
  storeVal("pan_number", item.pan_number);
  storeVal("adhar_card", item.adhar_card);
  storeVal("mobile", item.mobile);
  storeVal("address1", item.address1);
  storeVal("address2", item.address2);
  storeVal("city", item.city);
  storeVal("zip_no", item.zip_no);
  storeVal("state", item.state);
  storeVal("country_id", item.country_id);
  storeVal("country_name", item.country_name);
  storeVal("state_name", item.state_name);
  storeVal("email_address", item.email_address);
  storeVal("email", item.email_address || '');
  storeVal("user_role", userRole);
  sessionStorage.setItem("role_ids", JSON.stringify(roleIds));
  sessionStorage.setItem("permissions", JSON.stringify(permissions));
  sessionStorage.setItem("can_access_admin", canAccessAdmin ? '1' : '0');
  storeVal("role_name", roleName);
}

function Login() {
    const [formData] = useState(initialformData);
    const postUrl = "user/loginCheck"
    let history = useHistory();

    const {values,handleChange,handleSubmit} = useFormik({
        initialValues:formData,
        onSubmit:(values)=>{
          const callPOSTAPI = async () => {
          // Unified login: credentials only (no usertype). Admin SignIn may still send usertype:1.
          const res = await PostAction('post', {
            username: String(values.username || '').trim(),
            password: values.password,
          }, postUrl)
          if (res?.status === 'success' && Array.isArray(res.response) && res.response.length > 0) {
            const item = res.response[0]
            storeSession(item, {
              role_id: res.role_id,
              role_ids: res.role_ids,
              role_name: res.role_name,
              permissions: res.permissions,
              can_access_admin: res.can_access_admin,
            })
            history.push('/');
          } else {
            alert(res?.message || res?.data?.message || 'Login Failed!');
          }
          }
          callPOSTAPI()
        }
      })
  return (
    <>
    <Header />
    <PageHead title="Login" />
    <div className='container' style={{fontSize:20,minHeight:"615px"}}>
    <div className='card mx-auto' style={{maxWidth: 520}}>
    <div className="card-body">
    <Form onSubmit={handleSubmit}>
    <Row className='mb-3 g-2 align-items-center'>
        <Col xs={12} md="auto" className="text-md-end pe-md-2" style={{minWidth: 140}}>
            <label className='form-label mb-1 mb-md-0' htmlFor="login-username">Email or mobile</label>
        </Col>
        <Col xs={12} md className="ps-md-0">
            <input
            id="login-username"
            className='form-control'
            type="text"
            name="username"
            value={values.username}
            onChange={handleChange}
            autoComplete="username"
            placeholder="email@example.com or 10-digit mobile"
            />
        </Col>
    </Row>
    <Row className='mb-3 g-2 align-items-center'>
        <Col xs={12} md="auto" className="text-md-end pe-md-2" style={{minWidth: 140}}>
            <label className='form-label mb-1 mb-md-0' htmlFor="login-password">Password</label>
        </Col>
        <Col xs={12} md className="ps-md-0">
            <input
            id="login-password"
            className='form-control'
            type="password"
            name="password"
            value={values.password}
            onChange={handleChange}
            autoComplete="current-password"
            />
        </Col>
    </Row>
        <div className="text-center">
          <button className="btn btn-primary" type='submit'>Login</button>
        </div>
    </Form>
    </div>
    </div>
    </div>
   <Footer />
    </>
  
  )
}

export default Login
